import { FiestaInfoMessage } from 'src/shared';
import { t } from 'i18next';
import { Button } from 'primereact/button';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { PreCheckResultCode } from 'src/apis/api-client';
import logo from 'src/assets/images/fiesta.png';

export function NotPossibleView() {

  const navigate = useNavigate();
  const params = useParams();

  const [ reason, setReason ] = useState<PreCheckResultCode>();

  useEffect(
    () => {
      if (!params.reason) {
        navigate('/');
      } else {
        const reason = params.reason as PreCheckResultCode;
        if (reason) {
          setReason(reason);
        }
      }
    }
  );

  return (
    <div
      className='flex flex-column align-items-center justify-content-center'
      style={{ minHeight: '100vh', padding: '2rem' }}
    >
      <img src={logo} alt='FIESTA' style={{ width: '140px', marginBottom: '2rem' }} />
      {
        reason
        &&
        <FiestaInfoMessage
          icon='heart'
          title={t('domains.programs.views.join.notPossibleView.title', { interpolation: { escapeValue: false } })}
          textContent={t('domains.programs.views.join.notPossibleView.textContent.' + reason, { interpolation: { escapeValue: false } })}
        >
          <Button
            className='flex'
            label={t('domains.programs.views.programs.programsView.emptyMessage.buttonText')}
            style={{ maxWidth: '300px' }}
            onClick={() => { navigate('/app'); }}
          />
        </FiestaInfoMessage>
      }
    </div>
  );
}
